import { render, staticRenderFns } from "./StraightIcon.vue?vue&type=template&id=3f3cf52b&"
import script from "./StraightIcon.vue?vue&type=script&lang=js&"
export * from "./StraightIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports